/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import configuration */
import { OVERVIEW_ANOMALY_CONFIGS } from '@/config/kpi/overviewAnomalyConfig';

/* Import components */
import AnomalyMetricsOverview from '@/components/tabs/overview/metrics/AnomalyMetricsOverview';

function ClientsTab() {
    return (
        <AnomalyMetricsOverview
            anomalyConfigs={OVERVIEW_ANOMALY_CONFIGS}
            description="Overview of all available customers."
            gridClassName="xl:grid-cols-2"
            groupBy="customer"
            heading="Customers"
            idPrefix="customers"
        />
    );
}

export default ClientsTab;
